import { createSupabaseClient, type LynrxSupabaseClient } from '@lynrx/shared';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
  import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  console.warn(
    '[lynrx] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in env. ' +
      'Copy .env.example to apps/web/.env.local and fill in real values.'
  );
}

export const supabase: LynrxSupabaseClient = createSupabaseClient(url ?? '', anonKey ?? '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});
